import React from 'react';

import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { theme, Illustration } from 'fpay-ui';

const Layout = styled.div(
  ({ theme }) => css`
    flex-direction: column;
    background-color: ${theme.colors.gray200};
    max-height: 185px;
  `
);

const Container = styled.div`
  display: flex;
  background-color: #fff;
  width: 100%;
  max-height: 185px;
  padding-top: 32px;
  padding-bottom: 32px;
  border-radius: 6px;
  flex-direction: column;
  align-items: center;

  ${theme.breakpoint('md')} {
    border-radius: 6px;
    width: 100%;
    height: 205px;
  }
  ${theme.breakpoint('ll')} {
    border-radius: 6px;
    width: 100%;
  }
`;

const ContainerHeader = styled.div`
  display: none;
  ${theme.breakpoint('md')} {
    display: flex;
    width: 100%;
    display: flex;
    flex-direction: row;
    background-color: ${theme.colors.gray200};
    justify-content: space-between;
    margin-bottom: 10px;
  }
`;

const ContainerHeaderText = styled.div`
  display: none;
  ${theme.breakpoint('md')} {
    display: flex;
    ${({ theme }) => theme.textTypes['Caption-w400']};
    color: ${theme.colors.gray700};
    text-align: center;
    margin-left: 24px;
    margin-right: 24px;
  }
  ${theme.breakpoint('ll')} {
    ${({ theme }) => theme.textTypes['Overline-w500']};
    color: ${theme.colors.gray700};
    line-height: 1.3;
    letter-spacing: 0.16px;
    text-align: center;
  }
`;

const ImageError = styled(Illustration)(
  css`
    width: 61px;
    height: 63px;
    ${theme.breakpoint('md')} {
      width: 80px;
      height: 83px;
    }
    ${theme.breakpoint('ll')} {
      width: 88px;
      height: 91px;
    }
  `
);

const ContainerText = styled.div`
  max-width: 336px;
  margin-top: 16px;
  ${({ theme }) => theme.textTypes['Subtitle-1-w400']};
  line-height: 1.25;
  color: ${theme.colors.gray700};
  text-align: center;
  ${theme.breakpoint('md')} {
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: 1.43;
    text-align: center;
    margin-top: 16px;
  }
  ${theme.breakpoint('ll')} {
    margin-top: 24px;
  }
`;

const ErrorTableLastMovements = () => {
  const { t } = useTranslation();
  return (
    <Layout>
      <ContainerHeader>
        <ContainerHeaderText>FECHA</ContainerHeaderText>
        <ContainerHeaderText>CÓDIGO</ContainerHeaderText>
        <ContainerHeaderText>TIPO</ContainerHeaderText>
        <ContainerHeaderText>DETALLE</ContainerHeaderText>
        <ContainerHeaderText>MONTO</ContainerHeaderText>
      </ContainerHeader>
      <Container>
        <ImageError name="working_error" alt="Ayuda" />
        <ContainerText>{t('lastMovements.error')}</ContainerText>
      </Container>
    </Layout>
  );
};

export default ErrorTableLastMovements;
